import React, { useEffect, useRef } from 'react';
import FormError from '../../../FormError';

export default function SelectedBusiness({ selection, onChange, error }) {
    const headingRef = useRef(null);

    useEffect(() => {
        if (selection && headingRef.current) {
            headingRef.current.focus();
        }
    }, [selection]);

    if (!selection) {
        return null;
    }

    return (
        <div className="demo-add-selected-business border rounded p-2 mb-3" data-testid="demo-add-selected">
            {/* The error block is a sibling of the row, not a third flex item -
                as a flex child it competed with the button for the row's width. */}
            <div className="d-flex align-items-center justify-content-between">
                <div className="demo-island-text-wrap">
                    <h5 ref={headingRef} tabIndex={-1} className="mb-0">{selection.name}</h5>
                    <p className="mb-0 text-muted small">{selection.address}</p>
                </div>
                <button type="button" className="btn btn-outline-primary btn-sm demo-add-change-business" onClick={() => onChange(null)}>
                    {__('Change')}
                </button>
            </div>
            <FormError error_message={error} />
            {error &&
                <p className="text-muted small mb-0">{__('Choose another business')}</p>
            }
        </div>
    );
}
